import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Users.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListUserPage - Lazy-loaded ListUserPage component.
 */
const UserLicenceListPage = Loadable(
  lazy(() => import("./ListUserLicencePage"))
);

/**
 * Lazy-loaded component for rendering the View User page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewUserPage - Lazy-loaded ViewUserPage component.
 */
//const ViewUserPage = Loadable(lazy(() => import("./ViewUserPage")));

/**
 * Array containing route definitions for the User-related pages.
 * @constant {Object[]} UserRoutes - Array of User route objects.
 * @property {string} UserRoutes[].path - The path of the User route.
 * @property {React.ReactElement} UserRoutes[].element - The React element to be rendered for the User route.
 */
const UserRoutes = [
  {
    path: "list",
    element: <UserLicenceListPage />,
  },
  //   {
  //     path: "view/:user_id",
  //     element: <ViewUserPage />,
  //   },
];

export default UserRoutes;
